<template>
<div>
    <m-view-contact
        :contact="profile.employee_contact"
    />

     <div 
        style="text-align: right; margin-top: 5px;"
        v-show="can_write"
    >
        <v-btn 
            class="mx-2" fab dark small color="primary"
            v-on:click="onEditContact"
        >
            <v-icon dark> mdi-lead-pencil</v-icon>
        </v-btn>
    </div>

    <m-create-contact-dialog
          ref="create-contact-dialog"
          :organization_id="this.$route.params.organization_id"
      />
</div>
</template>

<script>
const _ = require('lodash');

export default {
   props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    methods: {
        onEditContact() {
          this.$refs['create-contact-dialog'].showCreateDialog(_.cloneDeep(this.profile.employee_contact),true,true,this.onUpsertContact);
        },

        onUpsertContact(new_contact)
        {
            this.$emit('upsert-contact',new_contact);
        }
    },

    computed: {
        can_write() {
            return this.profile.actor_permissions.can_write; 
        }
    },
}
</script>

<style lang="scss" scoped>

</style>